// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.switch-container {
  display: inline-flex;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #0669B3;
  background-color: white;
}
.switch-container .switch-label {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  cursor: pointer;
  user-select: none;
  background-color: white;
  color: #0669B3;
  font-weight: 500;
  font-size: 16px;
}
.switch-container .switch-label input {
  display: none;
}
.switch-container .switch-label.selected {
  background-color: #0669B3;
  color: white;
}
.switch-container .switch-label:not(.selected):hover {
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/RadioSwitchButton.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAHA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBARmB;AAcrB;AAJE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAhBiB;EAiBjB,cDWS;ECVT,gBAAA;EACA,eAAA;AAMJ;AAJI;EACE,aAAA;AAMN;AAHI;EACE,yBDEO;ECDP,YAAA;AAKN;AAFI;EACE,uBAAA;AAIN","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n$switch-active-bg: $pearl-blue;\n$switch-inactive-bg: white;\n$switch-inactive-text: $pearl-blue;\n\n.switch-container {\n  display: inline-flex;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid $pearl-blue;\n  background-color: $switch-inactive-bg;\n\n  .switch-label {\n    display: flex;\n    align-items: center;\n    padding: 6px 16px;\n    cursor: pointer;\n    user-select: none;\n    background-color: $switch-inactive-bg;\n    color: $switch-inactive-text;\n    font-weight: 500;\n    font-size: 16px;\n\n    input {\n      display: none;\n    }\n\n    &.selected {\n      background-color: $switch-active-bg;\n      color: white;\n    }\n\n    &:not(.selected):hover {\n      background-color: lighten($switch-inactive-bg, 5%);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
